import { render, staticRenderFns } from "./RincianPenarikan.vue?vue&type=template&id=2abb8738&"
import script from "./RincianPenarikan.vue?vue&type=script&lang=js&"
export * from "./RincianPenarikan.vue?vue&type=script&lang=js&"
import style0 from "./RincianPenarikan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports